export class GoogleWorkspaceServiceAccountInfo {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "clientId",
            "baseName": "clientId",
            "type": "string",
            "format": ""
        },
        {
            "name": "scopes",
            "baseName": "scopes",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceServiceAccountInfo.attributeTypeMap;
    }
    constructor() {
    }
}
